import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IInvitation } from '@app/models/signup';
import { CartState } from '@app/store/state/cart.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-invitation-b2b-client-select-account',
  templateUrl: './invitation-b2b-client-select-account.component.html',
  styleUrls: ['./invitation-b2b-client-select-account.component.scss']
})
export class InvitationB2bClientSelectAccountComponent implements OnInit {
  @Input() invitation: IInvitation;
  @Output() accountChosen = new EventEmitter();

  @Select(CartState.accounts)
  accounts$: Observable<any>;

  // links
  @Select(CartState.links)
  links$: Observable<any>;

  _accounts: any[];

  endpoints = window['ENDPOINTS'];
  current_account = window['CURRENT_ACCOUNT'];
  selectedAccount: any;
  loader = false;
  emmitedAccount: any;

  user = window['CONST_USER'];
  managerLink: string;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.accounts$.subscribe(accounts => {

      let findCurrentAccount: any = '';
      const acc: any[] = Object.assign([], accounts);
      if (acc && acc.length) {
        acc.sort((a, b) => {
          if (!this.canSwitchTo(a)) {
            return 1;
          } else if (!this.canSwitchTo(b)) {
            return -1;
          } else {
            return 0;
          }
        });
        try {
          findCurrentAccount = acc.find(
            (account: { id: any }) =>
              String(account?.id) === String(this.current_account?.id)
          );

        } catch { }

        if (findCurrentAccount && this.canSwitchTo(findCurrentAccount) && (findCurrentAccount.id !== this.invitation.account.id)) {
          acc.splice(acc.indexOf(findCurrentAccount), 1);
          acc.unshift(findCurrentAccount);
          this.selectedAccount = findCurrentAccount;
          this.emmitedAccount = this.selectedAccount;
        }
        this.loader = false;
      }
      this._accounts = acc;

      if (this._accounts.length === 1) {
        this.accountChosen.emit(this._accounts[0]);
      }

    });
  }

  clickContinue(): void {
    if (this.emmitedAccount && this.canSwitchTo(this.emmitedAccount)) {
      this.accountChosen.emit(this.emmitedAccount);
    }
  }

  accountselected(account): void {
    this.emmitedAccount = account;
  }

  canSwitchTo(account: any): boolean {
    if (account) {
      return (
        account.type === 'owner' &&
        !account.in_partnership_full_access
      );
    }
  }
}
